import app from 'flarum/forum/app';

import extenders from './extenders';

export { default as extend } from './extend';

import AuditLog from '../common/models/AuditLog';

app.initializers.add('kilowhat-audit', () => {
    app.store.models['kilowhat-audit'] = AuditLog;

    extenders();
});

// Expose compat API
import extCompat from '../forum/compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, extCompat);
